import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Spinner,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import UnitService from "../../../services/OrderingServices/UnitService";

// Validation Schema
const validationSchema = Yup.object({
  // username: Yup.string().required("Username is required"),
  name: Yup.string().required("Unit name is required"),
  description: Yup.string().required("Description is required"),

  ratio: Yup.string().required("Ratio is required"),

  // password: Yup.string()
  //   .min(6, "Password must be at least 6 characters")
  //   .matches(
  //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
  //     "Password must contain at least one uppercase, one lowercase, and one number"
  //   )
  //   .required("Password is required"),
});

const UnitForm = ({ selectedUnit, modal, toggleModal, fetchUnit }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedUnit?.id || "",

      // username: selectedUnit?.username || "",
      name: selectedUnit?.name || "",
      description: selectedUnit?.description || "",
      ratio: selectedUnit?.ratio || "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await UnitService.update(values.id, values);
          toast.success("Unit updated successfully.");
        } else {
          await UnitService.create(values);
          toast.success("New unit is added successfully");
          resetForm();
        }
        fetchUnit();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });
  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      backdropClassName="bg-dark bg-opacity-50"
      direction="end"
      className="shadow-lg animate__animated animate__slideInRight bg-white "
    >
      <OffcanvasHeader toggle={toggleModal}>
        {selectedUnit?.id ? "Update" : "Add"} Unit
      </OffcanvasHeader>
      <OffcanvasBody>

      <Form onSubmit={formik.handleSubmit}>
     
          <Row>
            <Col md={12}>
              <div className="form-floating mb-3">
                <Input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter unit name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  invalid={!!(formik.touched.name && formik.errors.name)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="name">Unit Name</Label>
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">
                    {formik.errors.name}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={12}>
              <div className="form-floating mb-3">
                <Input
                  id="ratio"
                  name="ratio"
                  type="text"
                  className="form-control"
                  placeholder="Enter ratio"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ratio}
                  invalid={!!(formik.touched.ratio && formik.errors.ratio)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="ratio">Ratio</Label>
                {formik.touched.ratio && formik.errors.ratio && (
                  <FormFeedback type="invalid">
                    {formik.errors.ratio}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={12}>
              {/* <div className="form-floating mb-3"> */}

              <label htmlFor="description">Description</label>

              <textarea
                id="description"
                name="description"
                className={`form-control ${
                  formik.touched.description && formik.errors.description
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Enter description"
                rows={5}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                style={{ padding: "1rem" }} // optional styling
              />
              {formik.touched.description && formik.errors.description && (
                <div className="invalid-feedback">
                  {formik.errors.description}
                </div>
              )}
              {/* </div> */}
            </Col>
          </Row>
        
          <div className="d-flex bg-white align-content-center align-items-center justify-content-between gap-2 position-absolute bottom-0 start-0 end-0 p-3 ">
                      <button className="btn btn-danger w-100 " onClick={toggleModal}>
                        Cancel
                      </button>
          
                      <Button
                        color="success"
                        type="submit"
                        disabled={loading}
                        className="w-100"
                      >
                        {loading && <Spinner size="sm" className="me-2" />}
                        {loading
                          ? selectedUnit?.id
                            ? "Updating..."
                            : "Creating..."
                          : selectedUnit?.id
                          ? "Update"
                          : "Create"}
                      </Button>
                    </div>
       
      </Form>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default UnitForm;
